import { useChatClass } from "../../theme";
import { MessageContainer, ChatMessage, DebugMessage } from "./styled";

export type MessageDirection = "user" | "system" | "debug";

export interface MessageProps extends React.ComponentPropsWithoutRef<"div"> {
  /** Direction of the message */
  direction: MessageDirection;
}

interface MessageComponent extends React.FC<MessageProps> {
  Container: typeof MessageContainer;
  Chat: typeof ChatMessage;
  Debug: typeof DebugMessage;
}

/** Message component that renders either ChatMessage or DebugMessage */
const Message: MessageComponent = ({ direction, children, ...rest }) => {
  const chatClass = useChatClass();
  if (direction === "user" || direction === "system") {
    return (
      <ChatMessage
        {...rest}
        $from={direction}
        className={chatClass("message", direction)}
      >
        {children}
      </ChatMessage>
    );
  }

  return (
    <DebugMessage
      {...rest}
      $orientation="center"
      className={chatClass("message", direction)}
    >
      {children}
    </DebugMessage>
  );
};

Message.Chat = ChatMessage;
Message.Debug = DebugMessage;
Message.Container = MessageContainer;

export { Message };
